'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _iconfont = require('@/components/iconfont');

var _iconfont2 = _interopRequireDefault(_iconfont);

var _nav = require('./nav');

var _nav2 = _interopRequireDefault(_nav);

var _store = require('@/store');

var _store2 = _interopRequireDefault(_store);

var _vuex = require('vuex');

var _imagePath = require('@/mixins/image-path');

var _imagePath2 = _interopRequireDefault(_imagePath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { indexRouter } from '@/config'
exports.default = {
  mixins: [_imagePath2.default],
  provide: function provide() {
    return {
      setVisible: this.setVisible
    };
  },
  data: function data() {
    return {
      headImg: '',
      userName: '',
      jzjyUrl: ''
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userChangeInfo'])),
  watch: {
    userChangeInfo: {
      handler: function handler(val) {
        this.userName = val.userName;
        this.getImgSrc('headImg', 'headImg', val.headImg);
      }
    },
    '$store.state.flushContent': function $storeStateFlushContent(val) {
      if (!val) {
        var token = sessionStorage.getItem('authLogin') || localStorage.getItem('authLogin');
        var isShowHead = !_store2.default.state.hideRouterName.includes(this.$route.name);
        if (token && token != 'null' && isShowHead) {
          this.getCurrentUser();
          // this.findDictList()
        }
      }
    }
  },
  created: function created() {
    var _this = this;

    // let token = sessionStorage.getItem('authLogin')
    // if (token && token != 'null') {
    //   this.getCurrentUser()
    // }
    setTimeout(function () {
      var token = sessionStorage.getItem('authLogin') || localStorage.getItem('authLogin');
      var isShowHead = !_store2.default.state.hideRouterName.includes(_this.$route.name);
      if (token && token != 'null' && isShowHead) {
        _this.getCurrentUser();
        // this.findDictList()
      }
    }, 100);
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)(['USER_CHANGE_INFO']), {
    // 下拉菜单点击事件
    onDropOperator: function onDropOperator(name) {
      switch (name) {
        case 'user':
          this.userClick();
          break;
        case 'lock':
          this.jumpReset();
          break;
        case 'poweroff':
          this.signOut();
          break;
        default:
          break;
      }
    },

    // 跳转到家长教育
    jumpJZJY: function jumpJZJY() {
      window.open(this.jzjyUrl, '_blank');
    },
    findDictList: function findDictList() {
      var _this2 = this;

      this.$ajax({
        url: 'api-basic/portal/open/dicttype/findDictList?typeCodes=BJOU_JZJYPT',
        method: 'GET'
      }).then(function (res) {
        if (res.data.code == 2000) {
          _this2.jzjyUrl = res.data.data[0];
          var _arr = res.data.data && res.data.data[0];
          if (_arr && _arr.dicts && _arr.dicts.length) {
            _this2.jzjyUrl = (_arr.dicts[0] || {}).dictName;
          }
        }
      });
    },

    //获取当前用户信息
    getCurrentUser: function getCurrentUser() {
      var _this3 = this;

      this.$ajax({
        url: 'api-ouser/portal/user/getCurrentUser',
        type: 'GET'
      }).then(function (_ref) {
        var data = _ref.data;

        _this3.userName = data.data.name;
        _this3.getImgSrc('headImg', 'headImg', data.data.headImg);
        _this3.USER_CHANGE_INFO({
          userName: data.data.name,
          headImg: data.data.headImg
        });
        // this.getImgSrc('headImg', 'headImg')
      });
    },

    // 联系我们
    jumpAbout: function jumpAbout() {
      this.toToBottom();
      // let routeUrl = this.$router.resolve({
      //   name: 'concatDetail'
      // })
      // window.open(routeUrl.href, '_blank')
    },
    toToBottom: function toToBottom() {
      var _this4 = this;

      var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      var scrollHt = document.body.scrollHeight || document.documentElement.scrollHeight;
      var scrollBot = document.body.offsetHeight || document.documentElement.offsetHeight;
      if (scrollHt - scrollBot + 50 <= scrollTop) return;
      var nextFrame = this.nextFrame;
      window.scrollTo(0, scrollTop + 100);
      nextFrame(function () {
        _this4.toToBottom();
      });
    },
    nextFrame: function nextFrame(fn) {
      var _this5 = this;

      window.requestAnimationFrame(function () {
        fn.call(_this5);
      });
    },

    // 跳转个人中心
    userClick: function userClick() {
      this.$router.push({
        name: 'mycourse'
      });
    },

    // 跳转修改密码
    jumpReset: function jumpReset() {
      // this.$router.push({
      //   name: 'resetPasswords'
      // })
      this.$router.push({
        name: 'mytoonaccount'
      });
    },

    // 注册跳转
    jumpRegister: function jumpRegister() {
      this.$router.push({
        name: 'registerPhone',
        query: {
          from: this.$route.name
        }
      });
      // this.$store.commit('FLUSHCONTENT', '正在进行注册，点击确定刷新注册登录状态！')
      // let routeUrl = this.$router.resolve({
      //   name: 'toonLogin',
      //   query: {
      //     type: 'bind'
      //   }
      // })
      // window.open(routeUrl.href, '_blank')
    },

    // 登录跳转
    jumpLogin: function jumpLogin(type) {
      sessionStorage.gotoQueryPage = '/';
      this.$store.commit('FLUSHCONTENT', 'login');
      // type 个人登录1 单位登录2
      // this.$router.push({
      //   name: 'login',
      //   query: {
      //     type: 'header'
      //   }
      // })
      // this.$store.commit('FLUSHCONTENT', '正在进行登录，点击确定刷新登录状态！')
      // let routeUrl = this.$router.resolve({
      //   name: 'toonLogin',
      //   query: {
      //     type: 'bind'
      //   }
      // })
      // window.open(routeUrl.href, '_blank')
    },

    //退出
    signOut: function signOut() {
      var _this6 = this;

      this.$ajax({
        url: 'logout',
        type: 'GET'
      }).then(function (res) {
        sessionStorage.clear();
        localStorage.clear();
        _this6.$Message.success(_this6.$t('login.logout'));
        location.reload();
      });
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.$Message.destroy();
  },

  components: {
    IconFont: _iconfont2.default,
    Nav: _nav2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//